import React from "react";
import styled from "styled-components";
import {
    SubHeading,
    Divider,
  } from "../../../Constants/typography";

const Wrapper = styled.section`
  padding-top: 40px;
`;

const SectionBlock = ({ heading, children }) => {
  return (
    <Wrapper>
      <SubHeading>{heading}</SubHeading>
      <Divider />
      {children}
    </Wrapper>
  );
};

export default SectionBlock;
